import { Button, ButtonProps } from "react-bootstrap";
import React, { FunctionComponent } from "react";
import { Link } from "react-router";
import { ArrowLeftIcon } from "../sidebar/icons";
import "./Buttons.scss";

export const PrimaryButton: FunctionComponent<ButtonProps> = (props) => {
  return <Button {...props} className={`primary-button ${props.className || ""}`} />;
};

export const BackButton: FunctionComponent<{
  to: string;
  className?: string;
}> = ({ to, className }: { to: string; className?: string }) => {
  return (
    <Link to={to} className={`btn btn-secondary back-button ${className || ""}`} title="Zurück" aria-label="Zurück">
      <ArrowLeftIcon />
    </Link>
  );
};
